<template>
  <div class="promotion-card">
    <div class="promotion-header">
      <div>
        <div class="promotion-type">
          <i class="fa fa-tags" aria-hidden="true"></i>
          ប្រូម៉ូសិនបញ្ចុះតម្លៃ
        </div>
        <div class="promotion-period">
          <span>{{ formatDate(promo.StartDate) }}</span>
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
          <span>{{ formatDate(promo.EndDate) }}</span>
        </div>
      </div>
      <div class="promotion-actions">
        <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('edit', promo)">
          <i class="fa fa-edit" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger" @click="$emit('delete', promo)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="tier-list">
      <div v-for="(line, i) in promo.JsonObject" :key="i" class="tier-row">
        <div>
          <span class="tier-label">ចំនួន</span>
          <strong>{{ line.MinQty }} - {{ maxQtyText(line.MaxQty) }}</strong>
        </div>
        <div class="tier-price">
          <span class="tier-label">តម្លៃលក់</span>
          <strong>{{ $money(line.Price) }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['promo'],
  methods: {
    formatDate(d) {
      return d ? String(d).substr(0, 10) : '-'
    },
    maxQtyText(value) {
      const maxQty = Number(value)
      return value === null || value === undefined || value === '' || maxQty <= 0 ? 'ឡើងទៅ' : value
    }
  }
}
</script>

<style scoped>
.promotion-card {
  background: #f5fbff;
  border: 1px solid #cfe5f6;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
}
.promotion-header {
  align-items: center;
  background: #e8f6fd;
  border-bottom: 1px solid #cfe5f6;
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
}
.promotion-type {
  color: #0856ab;
  font-weight: 700;
}
.promotion-type i {
  margin-right: 6px;
}
.promotion-period {
  align-items: center;
  color: #526579;
  display: flex;
  font-size: 12px;
  gap: 8px;
  margin-top: 4px;
}
.promotion-actions {
  display: flex;
  gap: 6px;
}
.promotion-actions .btn {
  align-items: center;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 32px;
}
.tier-list {
  display: grid;
  gap: 8px;
  padding: 10px 12px 12px;
}
.tier-row {
  align-items: center;
  background: #fff;
  border: 1px solid #dceaf6;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
}
.tier-label {
  color: #6d7f90;
  display: block;
  font-size: 11px;
}
.tier-row strong {
  color: #24384c;
  font-size: 13px;
}
.tier-price {
  text-align: right;
}
.tier-price strong {
  background: #f86c6b;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  min-width: 54px;
  padding: 3px 8px;
}
</style>
